import React, { useEffect, useState, useRef } from 'react';
import map from '../../images/india-map.png';

const stats = [
  {
    icon: 'bi bi-calendar-event',
    number: 20,
    label: 'Years of experience',
  },
  {
    icon: 'bi bi-people-fill',
    number: 150000,
    label: 'Clients served',
  },
  {
    icon: 'bi bi-person-badge-fill',
    number: 60,
    label: 'Investment experts',
  },
  {
    icon: 'bi bi-geo-alt-fill',
    number: 15000,
    label: 'Locations worldwide',
  },
];

const AnimatedNumber = ({ targetNumber }) => {
  const [count, setCount] = useState(0);
  const [startAnimation, setStartAnimation] = useState(false);
  const counterRef = useRef(null);

  const isDecimal = targetNumber % 1 !== 0;
  const isInLakhRange = targetNumber >= 100000;
  const isInThousandRange = targetNumber >= 1000 && targetNumber < 100000;

  // Use Intersection Observer to start the counter when 50% of the element is visible
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setStartAnimation(true);
          }
        });
      },
      { threshold: 0.5 } // 50% visibility threshold
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!startAnimation) return;

    let start = isDecimal ? 0.1 : 0;
    const end = targetNumber;
    const duration = 2000;

    const stepTime = isDecimal ? Math.abs(Math.floor(duration / (end * 10))) : Math.abs(Math.floor(duration / end));

    const incrementStep = isInLakhRange
      ? 300
      : isInThousandRange
      ? 10
      : isDecimal
      ? 0.1
      : 1;

    const interval = setInterval(() => {
      start += incrementStep;
      setCount(Math.min(start, end));

      if (start >= end) clearInterval(interval);
    }, stepTime);

    return () => clearInterval(interval);
  }, [startAnimation, targetNumber, isDecimal, isInLakhRange, isInThousandRange]);

  const formatNumber = (number) => {
    if (isInLakhRange) {
      return (number / 100000).toFixed(1) + 'L';
    } else if (isInThousandRange) {
      return (number / 1000).toFixed(1) + 'K';
    } else {
      return number.toFixed(isDecimal ? 1 : 0);
    }
  };

  const formattedNumber = formatNumber(count);

  return (
    <h3 className="text-success fw-bold counter" ref={counterRef}>
      {formattedNumber}+
    </h3>
  );
};

const WhyTaxNwealth = () => {
  return (
    <div className="why-taxnwealth py-5 text-center ">
      <div className='container'>
        <img src={map} alt="" />
      </div>
      <div className="container wealth">
        <h2 className="fw-bold mb-5 text-start">Why taxNwealth?</h2>
        <p className='text-start'>We have changed the way people do tax filing in India. We don’t just get your tax return filed within minutes but get you maximum refunds in shortest time.</p>
        <div className="container-box g-4 ">
          {stats.map((item, index) => (
            <div className="box" key={index}>
              <div className="icon-box mb-3 fs-1 text-dark">
                <i className={item.icon}></i>
              </div>
              <AnimatedNumber targetNumber={item.number} />
              <p className="text-muted counter-txt">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyTaxNwealth;
